import server from '../request'

// 上传文件到 服务器
export const uploadToWeb = function(data, progressFn, index) {
	return server({
		// baseURL: 'https://filemanage.52ngs.com/',
		baseURL: process.env.VUE_APP_UPLOAD_URL,
		url: 'group1/upload',
		method: 'post',
		headers: {
			'Content-Type': 'multipart/form-data'
		},
		data,
		onUploadProgress: function (progressEvent) {
            if (progressFn) {
                progressFn(progressEvent, index)
            }
        },
		requestConfig: {
			timeout: 1000000000000
		}
	})
}

// 上传到 数据库 --- 叶凡
export const saveFile = function(data, baseUrl) {
	return server({
		baseURL: baseUrl || process.env.VUE_APP_BASE_URL,
		url: 'sysFile/saveFile',
		method: 'post',
		data
	})
}

// 获取附件回显 --- 叶凡
export const getFiles = function(data, baseUrl) {
	return server({
		baseURL: baseUrl || process.env.VUE_APP_BASE_URL,
		url: 'sysFile/getFiles',
		method: 'post',
		data
	})
}

// 根据文件id删除文件 (删除数据库) --- 叶凡
export const deleteFile = function(data, baseUrl) {
	return server({
		baseURL: baseUrl || process.env.VUE_APP_BASE_URL,
		url: 'sysFile/deleteFile',
		method: 'post',
		data
	})
}



// WEBPACK FOOTER //
// ./src/api/module/upload.js